import axios from 'axios';

export const client = axios.create({
  // TODO: BaseURL 변경
  baseURL: process.env.REACT_APP_API_URL,
  // baseURL: 'http://localhost:3000',
  // baseURL: 'https://ehpcms.huraydev.net/',
});
